import { LeaderboardMeta } from 'types/leaderboard';
import React from 'react';

const LeaderboardContext = React.createContext(
  {} as {
    leaderboards: Record<string, LeaderboardMeta>;
    setLeaderboards: (t: Record<string, LeaderboardMeta>) => any;
    getChallenge: (id: string[]) => Promise<Record<string, LeaderboardMeta>>;
  }
);

export const LeaderboardProvider = LeaderboardContext.Provider;
export const LeaderboardConsumer = LeaderboardContext.Consumer;
export default LeaderboardContext;
